import React from 'react';
import { useNavigate } from 'react-router-dom';
import CartHotspot from '../components/hotspots/CartHotspot';
import HallHotspot from '../components/hotspots/HallHotspot';
import ClubHotspot from '../components/hotspots/ClubHotspot';
import ShopHotspot from '../components/hotspots/ShopHotspot';

function Golf() {
  const navigate = useNavigate();

  return (
    <div className="page golfPage">
      <div className="page-header">Golf Course</div>
      <div className="text-blocks">
        <div className="std-text">
          Whether you're organizing tournaments, scheduling and tracking tee times, managing the pro shop, directing staff or overseeing player experiences, start with the reliable foundation of Agilysys Golf.
        </div>
      </div>
      <div className="logo" onClick={() => navigate('/aboutus/agilysys')}>
        <img src="/assets/casino/Agilysys-Logo.svg" alt="Agilysys" style={{width:'100%',height:'auto'}} />
      </div>
      <div className="tap">
        <img src="/assets/casino/solutions/Green-Touch-Icon.gif" alt="" />
        <div className="tap-prompt">
          Tap on each section of the map{'\n'}To drill into the details
        </div>
      </div>
      <div className="golf-map">
        <div className="cart">
          <CartHotspot onClick={() => navigate('cart')} />
        </div>
        <div className="hall">
          <HallHotspot onClick={() => navigate('hall')} />
        </div>
        <div className="club">
          <ClubHotspot onClick={() => navigate('lounge')} />
        </div>
        <div className="shop">
          <ShopHotspot onClick={() => navigate('shop')} />
        </div>
      </div>
    </div>
  );
}

export default Golf;
